import React from 'react';
import { Divider } from '@mui/material';
import { useIsMobile } from '../../../hooks/useIsMobile';
import {
  AI_COLORS, AI_FONTS,
  ImgSlot, TipBox, AudioPlayer,
  PageHero, ContentWrap, SectionTitle, SubTitle, Card,
} from '../shared';
import img48 from '../../../imgs/adulto-idosos/48.png';

export default function SaudeGestacao() {
  const isMobile = useIsMobile();

  return (
    <div style={{ fontFamily: AI_FONTS.body, background: 'transparent' }}>
      <PageHero
        title="Saúde Bucal e a Gestação"
        subtitle="A gravidez é um período de muitas mudanças no corpo da mulher, e a boca também pode ser afetada."
        audio="saude-gestacao.m4a"
      />

      <ContentWrap>
        <p style={{ lineHeight: 1.75, marginTop: 0 }}>
          Durante a gestação, alterações hormonais podem deixar a gengiva mais sensível e aumentar o
          risco de alguns problemas bucais.
        </p>

        <SectionTitle>O que pode acontecer durante a gravidez?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>Algumas gestantes podem apresentar:</p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
            gap: 10,
            marginBottom: 16,
          }}
        >
          {[
            'Gengiva mais sensível',
            'Sangramento durante a escovação ou uso do fio dental',
            'Gengiva inchada ou avermelhada',
            'Aumento do acúmulo de placa bacteriana',
            'Maior risco de desenvolver gengivite',
            'Enjoo e vômitos, que podem causar desconforto na boca e nos dentes',
          ].map((item, i) => (
            <Card key={i} variant={i} style={{ padding: '12px 16px', fontSize: '0.93rem' }}>
              🤰 {item}
            </Card>
          ))}
        </div>

        <TipBox icon="💙">
          É importante lembrar que a gravidez não causa perda de dentes. Com os cuidados adequados,
          é possível manter a saúde bucal durante toda a gestação.
        </TipBox>

        <ImgSlot
          filename={img48}
          alt="Cuidados com a saúde bucal durante a gestação"
          caption="Cuidar da saúde bucal na gravidez é cuidar de você e do seu bebê"
        />

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>Quais sinais merecem atenção?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>Procure atendimento odontológico se perceber:</p>
        <ul style={{ paddingLeft: 20, lineHeight: 2 }}>
          <li>Sangramento frequente na gengiva</li>
          <li>Dor de dente</li>
          <li>Inchaço na gengiva</li>
          <li>Feridas que não melhoram</li>
          <li>Dificuldade para mastigar</li>
        </ul>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>Posso fazer tratamento odontológico durante a gravidez?</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>
          <strong>Sim!</strong> O atendimento odontológico é seguro durante a gestação e faz parte
          dos cuidados com a saúde da mãe e do bebê.
        </p>
        <p style={{ lineHeight: 1.75 }}>
          De forma geral, o <strong>segundo trimestre</strong> da gravidez costuma ser o período
          mais confortável e seguro para a realização da maioria dos tratamentos odontológicos. Por
          isso, não deixe de informar ao dentista que está grávida e em qual período da gestação
          você se encontra.
        </p>

        <Divider style={{ margin: '32px 0', borderColor: AI_COLORS.bgBlue100 }} />

        <SectionTitle>A importância do pré-natal odontológico</SectionTitle>
        <p style={{ lineHeight: 1.75 }}>
          Assim como o pré-natal médico, o pré-natal odontológico também é uma parte importante dos
          cuidados durante a gravidez.
        </p>
        <p style={{ lineHeight: 1.75 }}>
          Durante as consultas, o cirurgião-dentista poderá orientar sobre higiene bucal,
          alimentação saudável, prevenção de doenças e os cuidados necessários para manter a saúde
          da boca durante a gestação. Além disso, esse é um momento para esclarecer dúvidas e
          receber orientações sobre os primeiros cuidados com a saúde bucal do bebê.
        </p>

        <div
          style={{
            background: AI_COLORS.pink50,
            borderLeft: '4px solid #F06292',
            borderRadius: 10,
            padding: '18px 22px',
            marginTop: 20,
          }}
        >
          <p style={{ margin: 0, lineHeight: 1.75 }}>
            Cuidar da sua saúde bucal durante a gravidez é uma forma de cuidar da sua saúde e
            contribuir para o bem-estar do seu bebê. 💕
          </p>
        </div>

        <div style={{ marginTop: 24 }}>
          <SubTitle>Prefere ouvir?</SubTitle>
          <AudioPlayer src="saude-gestacao.m4a" />
        </div>
      </ContentWrap>
    </div>
  );
}
